// extracted by mini-css-extract-plugin
export var quantityInput = "_ml-0";